import * as Sentry from '@sentry/vue'
import { useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin(nuxtapp => {
  const runtimeConfig = useRuntimeConfig() as { public: { sentry: { dsn: string, environment: string } } }
  const router = useRouter()

  Sentry.init({
    app: nuxtapp.vueApp,
    dsn: runtimeConfig.public.sentry?.dsn,
    environment: runtimeConfig.public.sentry?.environment,
    tracesSampleRate: runtimeConfig.public.sentry?.environment === 'production' ? 0.2 : 1.0,
    profilesSampleRate: runtimeConfig.public.sentry?.environment === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: runtimeConfig.public.sentry?.environment === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    debug: false,
    _experiments: {
      enableLogs: true,
    },
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  })
})
